import React, { useContext, useState, useEffect } from "react"
import SessionContext from "components/Common/SessionContext"
import styled from "@emotion/styled"
import { css } from "@emotion/core"

const LoadWithAuth = ({ signedIn, signedOut }) => {
    const session = useContext(SessionContext)
    const shouldLoad = session && session.user ? true : false
    const [transition, setTransition] = useState(shouldLoad)
    const loadSignedIn = shouldLoad && session.user.uid !== "anonymous"
    const loadSignedOut = shouldLoad && session.user.uid === "anonymous"

    useEffect(() => {
        if (shouldLoad) {
            setTransition(true)
        }
    }, [shouldLoad])

    return (
        <>
            {loadSignedIn ? <FadeDiv show={transition}>{signedIn}</FadeDiv> : null}
            {loadSignedOut ? <FadeDiv show={transition}>{signedOut}</FadeDiv> : null}
        </>
    )
}

export default LoadWithAuth

const FadeDiv = styled.div`
    opacity: ${({ show }) => (show ? "100" : "0")};
    ${({ show }) => (!show ? "visibility: hidden;" : "")}
    transition: opacity 0.3s ease-in-out;
    -moz-transition: opacity 0.3s ease-in-out;
    -webkit-transition: opacity 0.3s ease-in-out;
`
